import exportFromJSON from "export-from-json";
import React, { useDeferredValue, useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import Select from "../../components/Commons/Select/SelectWithDeafult";
import "./table.css";

import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import NormalTable from "./normalTable/normalTable";
import { TotalAmount } from "../../Utils/TotalAmount";

const Table = (props) => {
  const [dataShow, setDataShow] = useState("");
  const [init, setInit] = useState([]);
  const [filter, setFilter] = useState(props.defaultStatus ?? "All");
  const [reset, setReset] = useState(false);
  const [isPrint, setIsprint] = useState(false);
  const [downloadDataTemplate, setDownloadDataTemplate] = useState([]);

  let pages = 1;

  let range = [];

  const [currPage, setCurrPage] = useState(0);

  const selectPage = (page) => {
    const start = Number(props.limit) * page;
    const end = start + Number(props.limit);

    setDataShow(props.bodyData.slice(start, end));

    setCurrPage(page);
  };

  useEffect(() => {
    if (props.bodyData) {
      const initDataShow =
        props.limit && props.bodyData
          ? props.bodyData.slice(0, Number(props.limit))
          : props.bodyData;
      setDataShow(initDataShow);
    }
  }, [props.bodyData, props.limit]);

  const [pag, setPag] = useState([]);

  useEffect(() => {
    if (init) {
      let HowMuch;
      if (parseInt(init.length / 10) < init.length / 10) {
        HowMuch = parseInt(init.length / 10) + 1;
        let arr = [];
        for (let i = 1; i <= HowMuch; i++) {
          arr.push(i);
        }
        setPag(arr);
      } else {
        HowMuch = parseInt(init.length / 10);
        let arr = [];
        for (let i = 1; i <= HowMuch; i++) {
          arr.push(i);
        }

        setPag(arr);
      }
    }
  }, [init]);

  // for menu selection  props.bodyData.slice(0,from*10)
  const [selected, setSelected] = useState();

  //for scroll to pagination element
  const refArray = React.useRef([]);

  const sliceTable = (from) => {
    let start = 10 * from - 10;
    setSelected(from);

    setDataShow(init.slice(start, from * 10));
  };

  const handleBackClick = (ind) => {
    if (refArray.current[ind]) {
      refArray.current[ind].scrollIntoView({ behavior: "smooth" });
    }
  };
  const [searchStr, setSeacrhStr] = useState("");
  const searchInTable = (e) => {
    let val = e.target.value;
    setSeacrhStr(val);
  };

  let finalValue = useDeferredValue(searchStr);

  useMemo(() => {
    if (props.bodyData) {
      let arr = [];

      for (let i = 0; i < props.bodyData.length; i++) {
        let obj = props.bodyData[i];
        let flag = false;

        for (const property in obj) {
          if (obj[property]) {
            let prop = obj[property].toString().toLowerCase();
            if (prop.includes(finalValue.toLowerCase())) {
              flag = true;
            }
          }
        }
        if (flag) {
          arr.push(props.bodyData[i]);
        }
      }

      setInit(arr);
    }
  }, [finalValue]);

  useEffect(() => {
    if (props.bodyData) {
      if (finalValue === "" && !filter) {
        setReset(true);
        setInit(props.bodyData);
        sliceTable(1);
      } else {
        sliceTable(1);
      }
    }
  }, [init, props.bodyData]);

  useEffect(() => {
    if (props.bodyData) {
      if (finalValue !== "" && !filter) {
        setReset(true);
        let arr = [];

        for (let i = 0; i < props.bodyData.length; i++) {
          let obj = props.bodyData[i];
          let flag = false;
          for (const property in obj) {
            if (obj[property]) {
              let prop = obj[property].toString().toLowerCase();
              if (prop.includes(finalValue.toLowerCase())) {
                flag = true;
              }
            }
          }
          if (flag) {
            arr.push(props.bodyData[i]);
          }
        }
        setInit(arr);
        sliceTable(1);
      } else {
        sliceTable(1);
      }
    }
  }, [finalValue]);

  //for select options
  const [opt, setOpt] = useState([]);

  useEffect(() => {
    let arr = [];
    if (props.bodyData) {
      for (let i = 0; i < props.bodyData.length; i++) {
        if (props.bodyData[i].Status && isNaN(props.bodyData[i].Status)) {
          if (!arr.includes(props.bodyData[i].Status.toLowerCase())) {
            arr.push(props.bodyData[i].Status.toLowerCase());
          }
        }
      }
    }
    let finalArr = [];
    finalArr.push({ status: "All" });
    for (let i = 0; i < arr.length; i++) {
      if (arr[i]) {
        finalArr.push({ status: arr[i] });
      }
    }
    setOpt(finalArr);
  }, [props.bodyData]);

  useEffect(() => {
    if (filter && filter.toLowerCase() !== "all") {
      if (props.bodyData) {
        let arr = [];

        for (let i = 0; i < props.bodyData.length; i++) {
          let obj = props.bodyData[i];

          if (filter && obj.Status) {
            if (obj.Status.toLowerCase() === filter.toLowerCase()) {
              arr.push(props.bodyData[i]);
            }
          }
        }

        setInit(arr);
        sliceTable(1);
      }
    } else {
      setInit(props.bodyData);
    }
  }, [filter]);

  //download xlsx file
  const xlsxDownloadFunc = () => {
    const data = downloadDataTemplate;
    const fileName = "Report";
    const exportType = "xls";

    exportFromJSON({ data, fileName, exportType });
  };

  //processing data for download the csv and xls files
  useEffect(() => {
    if (
      props.bodyData &&
      props.notShowInDownloadTemplate &&
      props.notShowInDownloadTemplate.length > 0
    ) {
      let newArr = [];
      let data = [...props.bodyData];

      for (let i = 0; i < data.length; i++) {
        let obj = Object.assign({}, data[i]);

        let notShowInDownloadTemplate = props.notShowInDownloadTemplate;
        for (let j = 0; j < notShowInDownloadTemplate.length; j++) {
          delete obj[notShowInDownloadTemplate[j]];
        }

        newArr.push(obj);
      }
      setDownloadDataTemplate(newArr);
    } else {
      setDownloadDataTemplate(props.bodyData);
    }
  }, [props.bodyData]);

  return (
    <>
      {isPrint && (
        <NormalTable
          close={() => setIsprint(false)}
          headData={props.headData}
          isPrint={isPrint}
          bodyData={props.bodyData}
          renderBody={(item, index) => props.renderBody(item, index)}
        />
      )}

      <div>
        <div className="tableFilterAndButtonSec">
          {props.showFilters && (
            <>
              {opt.length > 1 && (
                <Select
                  menu={opt}
                  setter={setFilter}
                  getField={"status"}
                  howToAccess={"status"}
                  reset={reset}
                  headLable={"Search with status"}
                  defaultTxt={props.defaultStatus ?? "All"}
                  style={{
                    marginTop: "10px",
                    width: "290px",
                    marginBottom: "10px",
                  }}
                />
              )}

              <div className="tableFilterAndButtonSec_btn">
                <button onClick={xlsxDownloadFunc}>
                  Excel <DownloadForOfflineIcon />
                </button>
                <CSVLink
                  data={downloadDataTemplate ? downloadDataTemplate : ""}
                >
                  <button>
                    Csv <DownloadForOfflineIcon />
                  </button>
                </CSVLink>
                <button onClick={() => setIsprint(!isPrint)}>
                  Pdf <DownloadForOfflineIcon />
                </button>
              </div>
            </>
          )}
          {!props.notShowTotalAmount && (
            <div className="total_Amt_container">
              {props.renderOtherTotalComponent ? (
                <>{props.renderOtherTotalComponent}</>
              ) : (
                <p>
                  Total Transaction Amount :{" "}
                  {TotalAmount(init, "Amt").toLocaleString("hi-IN", {
                    style: "currency",
                    currency: "INR",
                  })}
                  <br />
                  Total Transactions Count : {init && init.length}
                </p>
              )}
            </div>
          )}
        </div>

        {!props.hideSearch && (
          <div className="table_search_bar_container">
            <input
              className="table_search_bar"
              type={"text"}
              value={finalValue}
              onChange={searchInTable}
              placeholder="Search here..."
            />
          </div>
        )}

        <div className="table-wrapper">
          <table>
            {dataShow && props.renderBody ? (
              <>
                {props.headData && props.renderHead ? (
                  <thead>
                    {props.headData.map((item, index) =>
                      props.renderHead(item, index)
                    )}
                  </thead>
                ) : (
                  ""
                )}

                <tbody>
                  {dataShow.map((item, index) => props.renderBody(item, index))}
                </tbody>
              </>
            ) : (
              [1, 2, 3, 4, 5].map((el, i) => {
                return (
                  <tbody>
                    <tr style={{ height: "0px" }}>
                      <td className={`skeleton`} colSpan={10}></td>
                    </tr>
                  </tbody>
                );
              })
            )}
          </table>
        </div>
      </div>

      {init && init.length > 10 ? (
        <div className={"pagination"}>
          <p
            className="elm_prev"
            style={{ backgroundColor: selected === 1 && "#e1e1e1" }}
            onClick={() => {
              if (selected > 1) {
                sliceTable(selected - 1);
              }
              handleBackClick(selected - 4);
            }}
          >
            Prev
          </p>

          <div className="elm_no_container">
            {pag &&
              pag.map((elm, ind) => {
                return (
                  <p
                    ref={(ref) => {
                      refArray.current[ind] = ref; // took this from your guide's example.
                    }}
                    className="elm_no"
                    style={{
                      backgroundColor:
                        elm === selected && "var(--main-color-blue)",
                      color: elm === selected && "white",
                    }}
                    onClick={() => sliceTable(elm)}
                  >
                    {elm}
                  </p>
                );
              })}
          </div>

          <p
            className="elm_next"
            style={{ backgroundColor: selected === pag.length && "#e1e1e1" }}
            onClick={() => {
              if (selected < pag.length) {
                sliceTable(selected + 1);
              }
              handleBackClick(selected + 2);
            }}
          >
            Next
          </p>
        </div>
      ) : (
        <>
          {init && init.length === 0 && !props.hideSearch && (
            <p className="noData">no data found</p>
          )}
        </>
      )}
    </>
  );
};

export default Table;
